import api from "@/plugins/api/EntryPoint";

export default {
  getKhersonEnergoDataForPersonalAccount(callBackFn) {
    return api.get(`kherson-personal-account/get-personal-account-data`, callBackFn);
  },
  setKhersonEnergoDataForPersonalAccount(data, callBackFn) {
    return api.post(`kherson-personal-account/set-personal-account-data`, {ls: data.ls}, callBackFn);
  },
};
